module.exports = ".picture {\n    height: 200px;\n}\n"